import { isEmptyValue } from 'utils'

export const validateRequired = (value: string, label: string) => {
  if (isEmptyValue(value)) return Promise.reject(`${label} is required`)
  else return Promise.resolve()
}
